import React, { useEffect, useState } from "react";
import api from "../api/api";
import LeadershipMessage from "../components/LeadershipMessage";
import "../styles/global.css";

export default function About() {

  const [ngo, setNgo] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {

    const fetchData = async () => {

      try {

        setLoading(true);

        const [profileRes, orgRes] = await Promise.all([
          api.get("core/profile/"),
          api.get("core/ngo/")
        ]);

        // NGO PROFILE
        if (profileRes?.data) {

          const profileData = Array.isArray(profileRes.data)
            ? profileRes.data[0]
            : profileRes.data;

          setNgo(profileData);

        }

        // ORGANIZATION DATA
        if (orgRes?.data) {

          const orgData = Array.isArray(orgRes.data)
            ? orgRes.data[0]
            : orgRes.data;

          setOrg(orgData);

        }

      } catch (err) {

        console.error("Error loading NGO data:", err);
        setError("Failed to load NGO information.");

      } finally {

        setLoading(false);

      }

    };

    fetchData();

  }, []);


  if (loading) {
    return (
      <p style={{ textAlign: "center", marginTop: "40px" }}>
        Loading NGO information...
      </p>
    );
  }

  if (error) {
    return (
      <p style={{ textAlign: "center", color: "red", marginTop: "40px" }}>
        {error}
      </p>
    );
  }

  if (!ngo) {
    return (
      <p style={{ textAlign: "center", marginTop: "40px" }}>
        NGO information not available.
      </p>
    );
  }

  // MAP ADDRESS
  const address =
    org?.office_address ||
    org?.registered_location ||
    ngo?.address ||
    "";

  const mapQuery = encodeURIComponent(address);

  const mapLink = mapQuery
    ? `https://www.google.com/maps/search/?api=1&query=${mapQuery}`
    : "";

  const mapEmbed = mapQuery
    ? `https://www.google.com/maps?q=${mapQuery}&output=embed`
    : "";


  return (

    <div className="app">

      <section className="about-section" style={{ padding: "40px 20px" }}>

        <div className="about-container" style={{ maxWidth: "900px", margin: "0 auto" }}>

          <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
            About {ngo?.short_name || ngo?.name}
          </h1>

          {/* ABOUT */}
          {ngo?.about && (
            <p>
              <strong>About:</strong> {ngo.about}
            </p>
          )}

          {/* VISION */}
          {ngo?.vision && (
            <p>
              <strong>Vision:</strong> {ngo.vision}
            </p>
          )}

          {/* MISSION */}
          {ngo?.mission && (
            <p style={{ whiteSpace: "pre-line" }}>
              <strong>Mission:</strong> {ngo.mission}
            </p>
          )}

          {/* OBJECTIVES */}
          {ngo?.objectives && (
            <p style={{ whiteSpace: "pre-line" }}>
              <strong>Objectives:</strong> {ngo.objectives}
            </p>
          )}

          {/* LEADERSHIP MESSAGE */}

          <div style={{ marginTop: "50px" }}>
            <LeadershipMessage />
          </div>

          {/* ORGANIZATION TRANSPARENCY */}

          {(ngo?.registration_number ||
            ngo?.established_date ||
            ngo?.legal_identity) && (

            <div
              style={{
                marginTop: "50px",
                padding: "30px",
                background: "#f5f7fa",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
              }}
            >

              <h2 style={{ marginBottom: "20px" }}>
                Organization Transparency
              </h2>

              {ngo?.registration_number && (
                <p>
                  <strong>Registration Number:</strong> {ngo.registration_number}
                </p>
              )}

              {ngo?.established_date && (
                <p>
                  <strong>Established Date:</strong> {ngo.established_date}
                </p>
              )}

              {ngo?.legal_identity && (
                <p>
                  <strong>Legal Identity:</strong> {ngo.legal_identity}
                </p>
              )}

              {/* REGISTERED LOCATION */}
              {org?.registered_location && (
                <p>
                  <strong>Registered Location:</strong>{" "}
                  {mapLink ? (
                    <a href={mapLink} target="_blank" rel="noopener noreferrer">
                      📍 {org.registered_location}
                    </a>
                  ) : (
                    org.registered_location
                  )}
                </p>
              )}

              {/* OFFICE ADDRESS */}
              {org?.office_address && (
                <p>
                  <strong>Office Address:</strong>{" "}
                  {mapLink ? (
                    <a href={mapLink} target="_blank" rel="noopener noreferrer">
                      📍 {org.office_address}
                    </a>
                  ) : (
                    org.office_address
                  )}
                </p>
              )}

              {/* CONTACT NUMBERS */}

              {(org?.mobile_number_1 ||
                org?.mobile_number_2 ||
                org?.mobile_number_3) && (

                <>

                  <h3 style={{ marginTop: "20px" }}>
                    Contact Details
                  </h3>

                  {org?.mobile_number_1 && (
                    <p>
                      📞 <a href={`tel:${org.mobile_number_1}`}>{org.mobile_number_1}</a>
                    </p>
                  )}

                  {org?.mobile_number_2 && (
                    <p>
                      📞 <a href={`tel:${org.mobile_number_2}`}>{org.mobile_number_2}</a>
                    </p>
                  )}

                  {org?.mobile_number_3 && (
                    <p>
                      📞 <a href={`tel:${org.mobile_number_3}`}>{org.mobile_number_3}</a>
                    </p>
                  )}

                </>

              )}

              {/* EMAIL */}

              {ngo?.email && (

                <>

                  <h3 style={{ marginTop: "20px" }}>
                    Email
                  </h3>

                  <p>
                    ✉️ <a href={`mailto:${ngo.email}`}>{ngo.email}</a>
                  </p>

                </>

              )}

              {/* GOOGLE MAP */}

              {mapEmbed && (

                <div style={{ marginTop: "25px" }}>

                  <h3>Location Map</h3>

                  <iframe
                    title="NGO Location"
                    src={mapEmbed}
                    width="100%"
                    height="350"
                    style={{
                      border: 0,
                      borderRadius: "10px"
                    }}
                    loading="lazy"
                    allowFullScreen
                  />

                </div>

              )}

            </div>

          )}

        </div>

      </section>

      <footer style={{ textAlign: "center", marginTop: "40px" }}>
        © {new Date().getFullYear()} SRV NGO. All rights reserved.
      </footer>

    </div>

  );

}